import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { TreeNodeComponent } from "../../Components/TreeView/NodeComponents/TreeNodeComponent";
import { ITreeField } from "./ITreeField";
import { TextComponent } from "../../Components/TextComponent";

export type UsedTreeFieldComponentProps = {
    model: ITreeField;
    node: TreeNodeComponent;
}

export class UsedTreeFieldComponent extends JSXComponent {
    private props: UsedTreeFieldComponentProps;

    constructor(props: UsedTreeFieldComponentProps) {
        super(props);
    }

    element: HTMLElement;
    getElement = () => {
        this.element = <div className="tree-item tree-drop" data-field={this.props.model.value}>
            <span>{this.props.model.name}</span>

            {this.props.model.isIteration
                ? <TextComponent createFormGroup={false}
                    model={this.props.model}
                    field="iteration"
                    restrictTo="integer"
                    additionalCssClasses="ml-auto iteration-to-show"
                    showTooltip={true}
                />
                : []}
            <TextComponent createFormGroup={false}
                model={this.props.model}
                field="width"
                additionalCssClasses="ml-auto input-width"
                name={Resources.Common.width}
                showLabel={false}
                showTooltip={true} />
            <i className="fas fa-trash pointer"></i>
        </div>;

        let widthInput = this.element.querySelector(".input-width") as HTMLInputElement;
        if (widthInput) {
            widthInput.onkeydown = (ev: KeyboardEvent) => { if (ev.key === " ") return false; }
        }
    }

    render() {
        if (this.props.model.isIteration && (!this.props.model.iteration || this.props.model.iteration == 0)) {
            // set the current year as default value
            this.props.model.iteration = new Date().getFullYear();
        }

        this.getElement();
        this.element.querySelector(".fa-trash").addEventListener("click", this.onDeleteClick);
        return this.element;
    }

    onDeleteClick = () => {
        this.props.model.isDeleted = true;
        this.props.node.element.parentElement.removeChild(this.props.node.element);
    }
}